import { render, staticRenderFns } from "./PhotoSection.vue?vue&type=template&id=45afe393"
import script from "./PhotoSection.vue?vue&type=script&lang=js"
export * from "./PhotoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports